/* eslint-disable */
import React from 'react'
import EzCancelPlus from 'SVGPath/EzcancelPlusIcon'

const componentMap = {
  error: (
    <svg
      width="60"
      height="60"
      viewBox="0 0 18 16"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill="#FFBA00"
    >
      <defs>
        <path
          id="warning-a"
          d="M10.969 9.136h2.062v5.606H10.97V9.137zm0 7.01h2.062v1.868H10.97v-1.869zm9.948 2.783L12.566 4.325A.649.649 0 0 0 12 4a.65.65 0 0 0-.566.325l-8.35 14.604a.626.626 0 0 0 .004.636c.118.196.33.317.561.317h16.702c.23 0 .442-.121.56-.317a.631.631 0 0 0 .006-.636z"
        />
      </defs>
      <use
        fillRule="evenodd"
        xlinkHref="#warning-a"
        transform="translate(-3 -4)"
      />
    </svg>
  ),
  cfw: (
   <></>
  ),
  web_check_in: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="19"
      viewBox="0 0 14 19"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          fillOpacity="0"
          d="M0 0H18V18H0z"
          transform="translate(-2)"
        />
        <path
          fill="#3669C9"
          fillRule="nonzero"
          d="M14.03 0l.145.007A1.5 1.5 0 0115.531 1.5v15.004l-.007.145a1.5 1.5 0 01-1.493 1.355h-10l-.145-.006a1.5 1.5 0 01-1.355-1.494V1.5l.007-.144A1.5 1.5 0 014.03 0h10zm0 1h-2.54a2.504 2.504 0 01-2.45 2.004c-1.21 0-2.22-.862-2.45-2.004H4.03l-.09.008a.5.5 0 00-.41.492v15.004l.009.09a.5.5 0 00.492.41h10a.5.5 0 00.5-.5V1.5l-.008-.09A.5.5 0 0014.03 1zm-3.219 13.508v1h-3.5v-1h3.5zm.907-8.257l.762.876-4.176 3.57a.587.587 0 01-.765-.003l-.056-.055L5.6 8.497l.88-.76 1.501 1.707 3.737-3.193zm-1.265-5.247H7.627l.018.052.057.125c.247.488.755.823 1.338.823l.144-.007.14-.02a1.507 1.507 0 001.111-.921l.018-.052z"
          transform="translate(-2)"
        />
      </g>
    </svg>
  ),
  vas: (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 14 14"
      >
        <defs>
          <linearGradient
            id="prefix__a"
            x1="50%"
            x2="50%"
            y1="-6.44%"
            y2="113.78%"
          >
            <stop offset="0%" stopColor="#89D500" />
            <stop offset="100%" stopColor="#43A200" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
          <path
            fill="url(#prefix__a)"
            d="M.199 1.376a17.642 17.642 0 0113.651-.004l.009.004C14.615 7.15 12.335 11.359 7.017 14 1.552 11.13-.72 6.922.2 1.376z"
          />
          <path
            fill="#FFF"
            d="M10.182 3.218c.752-.514 1.648.609.886 1.13L8.705 5.812l-.445 4.422-.735.548-.611-3.859-5.076 2.777a10.27 10.27 0 01-.474-.74l4.747-3.218-3.118-1.624.726-.562 4.183 1.075z"
          />
        </g>
      </svg>
    </div>
  ),
  info_outline: (
    <svg
      width="10px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>info-outline</title>
      <g
        id="in-App"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Android-icons"
          transform="translate(-16.000000, -400.000000)"
          fill="#3366CC"
        >
          <g id="info-outline" transform="translate(16.000000, 400.000000)">
            <path
              d="M9,15 L11,15 L11,9 L9,9 L9,15 L9,15 Z M10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 C20,4.5 15.5,0 10,0 L10,0 Z M10,18 C5.6,18 2,14.4 2,10 C2,5.6 5.6,2 10,2 C14.4,2 18,5.6 18,10 C18,14.4 14.4,18 10,18 L10,18 Z M9,7 L11,7 L11,5 L9,5 L9,7 L9,7 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  invoice: (
    <svg
      width="16px"
      height="18px"
      viewBox="0 0 16 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Shape</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="gst-invoice"
          transform="translate(-1.000000, 0.000000)"
          fillRule="nonzero"
          stroke="#3669C9"
        >
          <path d="" id="Shape" />
        </g>
      </g>
    </svg>
  ),
  customer_support: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          fill="#3669C9"
          fillRule="nonzero"
          d="M12.5 4C8.889 4 6 6.91 6 10.545v5.091c0 1.237.939 2.182 2.167 2.182h2.166V12H7.444v-1.455c0-2.836 2.24-5.09 5.056-5.09 2.817 0 5.056 2.254 5.056 5.09V12h-2.89v5.818h2.89v.727H12.5V20h4.333C18.061 20 19 19.055 19 17.818v-7.273C19 6.91 16.111 4 12.5 4z"
        />
      </g>
    </svg>
  ),
  customer_support_desktop: (
    <svg width="44" height="44">
      <path
        d="M22 0c12.1502645 0 22 9.8497355 22 22s-9.8497355 22-22 22S0 34.1502645 0 22 9.8497355 0 22 0zm-.4 10v.0099899l-.3370262.0058487c-5.0339917.174982-9.0834826 4.254693-9.2571684 9.3262518L12 19.6816317v5.371371c0 1.9783334 1.5918764 3.5820896 3.5555556 3.5820896h2.1333333c.7854716 0 1.4222222-.6415025 1.4222222-1.4328359V22.903749c0-.7913334-.6367506-1.4328358-1.4222222-1.4328358l-3.5555556-.0010625v-1.788219l.006559-.31819c.1612542-3.904108 3.2760873-7.0395913 7.1523322-7.1979236L21.6 12.1592437v-.00999l.3077755.0062745c3.9810083.1626116 7.1588912 3.4654759 7.1588912 7.5161136v1.7924776l-3.5555556.0006565c-.7854716 0-1.4222222.6415024-1.4222222 1.4328358v4.2985074c0 .7913334.6367506 1.4328359 1.4222222 1.4328359l2.8442608.0008008c-.9746711 1.8353874-2.8555252 3.1089654-5.0402909 3.2139682l-.2928588.0070223H21.6V34h1.4222222l.3212935-.0062421c4.2634884-.1659461 7.6897488-3.620235 7.8505791-7.9165438L31.2 25.761194v-6.0895522l-.0058054-.3395414C31.0166491 14.1478404 26.7891265 10 21.6 10z"
        fill="#36C"
        fillRule="nonzero"
      />
    </svg>
  ),
  ezcancel: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="23"
      height="26"
      viewBox="0 0 43 48"
    >
      <defs>
        <linearGradient id="logo-b" x1="50%" x2="50%" y1="-31.726%" y2="100%">
          <stop offset="0%" stopColor="#FFC900" />
          <stop offset="100%" stopColor="#F77728" />
        </linearGradient>
        <path
          id="logo-a"
          d="M0.609635134,5.86740178 C-2.21258602,23.9335647 4.76400336,37.6410365 21.5394033,46.9898172 C37.8627946,38.3862208 44.8628842,24.678749 42.5396721,5.86740178 L35.342716,2.6635583 C26.5697556,-1.24186947 16.551258,-1.23925306 7.7803386,2.67075643 L0.609635134,5.86740178 L0.609635134,5.86740178 Z"
        />
        <filter
          id="logo-c"
          width="107%"
          height="106.9%"
          x="-3.5%"
          y="-3.8%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="-3" in="SourceAlpha" result="shadowOffsetInner1" />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner1"
          />
          <feColorMatrix
            in="shadowInnerInner1"
            values="0 0 0 0 0.129411765   0 0 0 0 0.129411765   0 0 0 0 0.129411765  0 0 0 0.116559222 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(0 1)">
        <mask id="logo-d" fill="#fff">
          <use xlinkHref="#logo-a" />
        </mask>
        <use fill="url(#logo-b)" xlinkHref="#logo-a" />
        <use fill="#000" filter="url(#logo-c)" xlinkHref="#logo-a" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M21.389751,9.38014733 C27.7401502,9.38014733 32.888166,14.5132747 32.888166,20.8453081 C32.888166,27.1773416 27.7401502,32.310469 21.389751,32.310469 C15.0393517,32.310469 9.89133591,27.1773416 9.89133591,20.8453081 C9.89133591,14.5132747 15.0393517,9.38014733 21.389751,9.38014733 Z M28.0971597,18.934448 L14.6823422,18.934448 L14.6823422,22.7561683 L28.0971597,22.7561683 L28.0971597,18.934448 Z"
          mask="url(#logo-d)"
        />
      </g>
    </svg>
  ),
  'CT FLEXMAX': <EzCancelPlus width="20px" height="20px" />,
  ezcancel_banner: (
    <></>
  ),
  info_icon: (
    <svg viewBox="0 0 12 12" width="16" height="16">
      <path
        d="M6 0c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6zm0 .75A5.257 5.257 0 00.75 6 5.257 5.257 0 006 11.25 5.257 5.257 0 0011.25 6 5.257 5.257 0 006 .75zm.577 4.525V9.4H5.452V5.275h1.125zM6.015 4.15a.75.75 0 100-1.5.75.75 0 000 1.5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
  arrow_left: (
    <svg viewBox="0 0 24 24" height="18">
      <g fill="none" fillRule="evenodd">
        <path fill="#FFF" d="M0 0h24v24H0z" />
        <path fill="#FFF" d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M19 11.125H8.325l4.9-4.9L12 5l-7 7 7 7 1.225-1.225-4.9-4.9H19z"
        />
      </g>
    </svg>
  ),
  arrow_left_pwa: (
    <svg viewBox="0 0 24 24" height="24" width="24">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#007aff"
          d="M19 11.125H8.325l4.9-4.9L12 5l-7 7 7 7 1.225-1.225-4.9-4.9H19z"
        />
      </g>
    </svg>
  ),
  arrow_right: (
    <svg viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path fill="#FFF" d="M24 24H0V0h24z" />
        <path fill="#FFF" d="M24 24H0V0h24z" />
        <path
          fill="currentColor"
          d="M5 12.875h10.675l-4.9 4.9L12 19l7-7-7-7-1.225 1.225 4.9 4.9H5z"
        />
      </g>
    </svg>
  ),
  modal_close: (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <path
          d="M20.097 3.863A11.395 11.395 0 0011.98.5a11.395 11.395 0 00-8.117 3.363A11.395 11.395 0 00.5 11.98c0 3.069 1.192 5.946 3.363 8.117a11.395 11.395 0 008.117 3.363c3.069 0 5.946-1.193 8.117-3.363a11.395 11.395 0 003.363-8.117c0-3.069-1.193-5.947-3.363-8.117z"
          stroke="#000"
        />
        <path
          d="M17.259 6.7a.679.679 0 00-.963 0l-4.316 4.317L7.664 6.7a.679.679 0 00-.963 0 .679.679 0 000 .963l4.316 4.316L6.7 16.296a.679.679 0 000 .963.685.685 0 00.479.202.664.664 0 00.479-.202l4.316-4.316 4.316 4.316a.685.685 0 00.479.202.656.656 0 00.479-.202.679.679 0 000-.963l-4.306-4.316 4.316-4.316a.679.679 0 000-.963z"
          fill="#000"
        />
      </g>
    </svg>
  ),
  arrow: (
    <svg width="14" height="9" fill="currentColor">
      <g fill="none" fillRule="evenodd">
        <path d="M15 12H-1V-4h16z" />
        <path
          stroke="#FFF"
          strokeWidth=".5"
          fill="currentColor"
          d="M11.59 8L7 3.42 2.41 8 1 6.59l6-6 6 6z"
        />
      </g>
    </svg>
  ),
  infoIcon: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path
        d="M6 0c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6zm0 .75A5.257 5.257 0 00.75 6 5.257 5.257 0 006 11.25 5.257 5.257 0 0011.25 6 5.257 5.257 0 006 .75zm.577 4.525V9.4H5.452V5.275h1.125zM6.015 4.15a.75.75 0 100-1.5.75.75 0 000 1.5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
  tooltipInfoIcon: (
    <svg
      viewBox="0 0 14 14"
      width="16"
      height="16"
      className="fw-200 secondary-grey"
    >
      <path
        d="M6 0c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6zm0 .75A5.257 5.257 0 00.75 6 5.257 5.257 0 006 11.25 5.257 5.257 0 0011.25 6 5.257 5.257 0 006 .75zm.577 4.525V9.4H5.452V5.275h1.125zM6.015 4.15a.75.75 0 100-1.5.75.75 0 000 1.5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
  greyInfoIcon: (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.82422 9C6.92422 9 7.00489 8.96956 7.06622 8.90867C7.12711 8.84733 7.15755 8.76667 7.15755 8.66667V5.65C7.15755 5.56111 7.12422 5.486 7.05755 5.42467C6.99089 5.36378 6.91311 5.33333 6.82422 5.33333C6.72422 5.33333 6.64355 5.36667 6.58222 5.43333C6.52133 5.5 6.49089 5.57778 6.49089 5.66667V8.68333C6.49089 8.77222 6.52422 8.84733 6.59089 8.90867C6.65755 8.96956 6.73533 9 6.82422 9ZM6.82422 4.38333C6.93533 4.38333 7.03266 4.34444 7.11622 4.26667C7.19933 4.18889 7.24089 4.08889 7.24089 3.96667C7.24089 3.85556 7.19933 3.76111 7.11622 3.68333C7.03266 3.60556 6.93533 3.56667 6.82422 3.56667C6.71311 3.56667 6.61577 3.60556 6.53222 3.68333C6.44911 3.76111 6.40755 3.85556 6.40755 3.96667C6.40755 4.08889 6.44911 4.18889 6.53222 4.26667C6.61577 4.34444 6.71311 4.38333 6.82422 4.38333ZM6.82422 12C5.99089 12 5.20755 11.8444 4.47422 11.5333C3.74089 11.2222 3.10489 10.7973 2.56622 10.2587C2.02711 9.71956 1.602 9.08333 1.29089 8.35C0.979774 7.61667 0.824219 6.83333 0.824219 6C0.824219 5.16667 0.979774 4.38333 1.29089 3.65C1.602 2.91667 2.02711 2.28044 2.56622 1.74133C3.10489 1.20267 3.74089 0.777778 4.47422 0.466667C5.20755 0.155556 5.99089 0 6.82422 0C7.65755 0 8.44089 0.155556 9.17422 0.466667C9.90755 0.777778 10.5438 1.20267 11.0829 1.74133C11.6216 2.28044 12.0464 2.91667 12.3576 3.65C12.6687 4.38333 12.8242 5.16667 12.8242 6C12.8242 6.83333 12.6687 7.61667 12.3576 8.35C12.0464 9.08333 11.6216 9.71956 11.0829 10.2587C10.5438 10.7973 9.90755 11.2222 9.17422 11.5333C8.44089 11.8444 7.65755 12 6.82422 12ZM6.82422 11.3333C8.302 11.3333 9.56044 10.814 10.5996 9.77533C11.6382 8.73622 12.1576 7.47778 12.1576 6C12.1576 4.52222 11.6382 3.26378 10.5996 2.22467C9.56044 1.186 8.302 0.666667 6.82422 0.666667C5.34644 0.666667 4.08822 1.186 3.04955 2.22467C2.01044 3.26378 1.49089 4.52222 1.49089 6C1.49089 7.47778 2.01044 8.73622 3.04955 9.77533C4.08822 10.814 5.34644 11.3333 6.82422 11.3333Z"
        fill="#1A1A1A"
      />
    </svg>
  ),
  greyInfoIconBig: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.82422 9C6.92422 9 7.00489 8.96956 7.06622 8.90867C7.12711 8.84733 7.15755 8.76667 7.15755 8.66667V5.65C7.15755 5.56111 7.12422 5.486 7.05755 5.42467C6.99089 5.36378 6.91311 5.33333 6.82422 5.33333C6.72422 5.33333 6.64355 5.36667 6.58222 5.43333C6.52133 5.5 6.49089 5.57778 6.49089 5.66667V8.68333C6.49089 8.77222 6.52422 8.84733 6.59089 8.90867C6.65755 8.96956 6.73533 9 6.82422 9ZM6.82422 4.38333C6.93533 4.38333 7.03266 4.34444 7.11622 4.26667C7.19933 4.18889 7.24089 4.08889 7.24089 3.96667C7.24089 3.85556 7.19933 3.76111 7.11622 3.68333C7.03266 3.60556 6.93533 3.56667 6.82422 3.56667C6.71311 3.56667 6.61577 3.60556 6.53222 3.68333C6.44911 3.76111 6.40755 3.85556 6.40755 3.96667C6.40755 4.08889 6.44911 4.18889 6.53222 4.26667C6.61577 4.34444 6.71311 4.38333 6.82422 4.38333ZM6.82422 12C5.99089 12 5.20755 11.8444 4.47422 11.5333C3.74089 11.2222 3.10489 10.7973 2.56622 10.2587C2.02711 9.71956 1.602 9.08333 1.29089 8.35C0.979774 7.61667 0.824219 6.83333 0.824219 6C0.824219 5.16667 0.979774 4.38333 1.29089 3.65C1.602 2.91667 2.02711 2.28044 2.56622 1.74133C3.10489 1.20267 3.74089 0.777778 4.47422 0.466667C5.20755 0.155556 5.99089 0 6.82422 0C7.65755 0 8.44089 0.155556 9.17422 0.466667C9.90755 0.777778 10.5438 1.20267 11.0829 1.74133C11.6216 2.28044 12.0464 2.91667 12.3576 3.65C12.6687 4.38333 12.8242 5.16667 12.8242 6C12.8242 6.83333 12.6687 7.61667 12.3576 8.35C12.0464 9.08333 11.6216 9.71956 11.0829 10.2587C10.5438 10.7973 9.90755 11.2222 9.17422 11.5333C8.44089 11.8444 7.65755 12 6.82422 12ZM6.82422 11.3333C8.302 11.3333 9.56044 10.814 10.5996 9.77533C11.6382 8.73622 12.1576 7.47778 12.1576 6C12.1576 4.52222 11.6382 3.26378 10.5996 2.22467C9.56044 1.186 8.302 0.666667 6.82422 0.666667C5.34644 0.666667 4.08822 1.186 3.04955 2.22467C2.01044 3.26378 1.49089 4.52222 1.49089 6C1.49089 7.47778 2.01044 8.73622 3.04955 9.77533C4.08822 10.814 5.34644 11.3333 6.82422 11.3333Z"
        fill="#1A1A1A"
      />
    </svg>
  ),
  superCoinWhite: (
    <></>
  ),
  walletLogin: (
    <svg
      width="40"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="8.5"
        y1="6"
        x2="8.5"
        y2="26"
        stroke="white"
        stroke-dasharray="1 1"
      />
      <path
        d="M29 12.875H29.75C29.75 12.4608 29.4142 12.125 29 12.125V12.875ZM29 19.125V19.875C29.4142 19.875 29.75 19.5392 29.75 19.125H29ZM22.5 15.25C22.0858 15.25 21.75 15.5858 21.75 16C21.75 16.4142 22.0858 16.75 22.5 16.75V15.25ZM22.513 16.75C22.9272 16.75 23.263 16.4142 23.263 16C23.263 15.5858 22.9272 15.25 22.513 15.25V16.75ZM5.6 6.75H26.4V5.25H5.6V6.75ZM28.25 8.5V23.5H29.75V8.5H28.25ZM26.4 25.25H5.6V26.75H26.4V25.25ZM3.75 23.5V8.5H2.25V23.5H3.75ZM5.6 25.25C4.55028 25.25 3.75 24.439 3.75 23.5H2.25C2.25 25.3224 3.77784 26.75 5.6 26.75V25.25ZM28.25 23.5C28.25 24.439 27.4497 25.25 26.4 25.25V26.75C28.2222 26.75 29.75 25.3224 29.75 23.5H28.25ZM26.4 6.75C27.4497 6.75 28.25 7.56095 28.25 8.5H29.75C29.75 6.67762 28.2222 5.25 26.4 5.25V6.75ZM5.6 5.25C3.77784 5.25 2.25 6.67762 2.25 8.5H3.75C3.75 7.56095 4.55028 6.75 5.6 6.75V5.25ZM21.85 13.625H29V12.125H21.85V13.625ZM28.25 12.875V19.125H29.75V12.875H28.25ZM29 18.375H21.85V19.875H29V18.375ZM21.85 18.375C20.4413 18.375 19.35 17.2842 19.35 16H17.85C17.85 18.1676 19.6689 19.875 21.85 19.875V18.375ZM21.85 12.125C19.6689 12.125 17.85 13.8324 17.85 16H19.35C19.35 14.7158 20.4413 13.625 21.85 13.625V12.125ZM22.5 16.75H22.513V15.25H22.5V16.75Z"
        fill="white"
      />
    </svg>

    //   <svg width="38" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <path d="M27 7.875H27.75C27.75 7.46079 27.4142 7.125 27 7.125V7.875ZM27 14.125V14.875C27.4142 14.875 27.75 14.5392 27.75 14.125H27ZM20.5 10.25C20.0858 10.25 19.75 10.5858 19.75 11C19.75 11.4142 20.0858 11.75 20.5 11.75V10.25ZM20.513 11.75C20.9272 11.75 21.263 11.4142 21.263 11C21.263 10.5858 20.9272 10.25 20.513 10.25V11.75ZM3.60003 1.75H24.4V0.25H3.60003V1.75ZM26.25 3.5V18.5H27.75V3.5H26.25ZM24.4 20.25H3.60003V21.75H24.4V20.25ZM1.75003 18.5V3.5H0.250031V18.5H1.75003ZM3.60003 20.25C2.55031 20.25 1.75003 19.439 1.75003 18.5H0.250031C0.250031 20.3224 1.77787 21.75 3.60003 21.75V20.25ZM26.25 18.5C26.25 19.439 25.4498 20.25 24.4 20.25V21.75C26.2222 21.75 27.75 20.3224 27.75 18.5H26.25ZM24.4 1.75C25.4498 1.75 26.25 2.56095 26.25 3.5H27.75C27.75 1.67762 26.2222 0.25 24.4 0.25V1.75ZM3.60003 0.25C1.77787 0.25 0.250031 1.67762 0.250031 3.5H1.75003C1.75003 2.56095 2.55031 1.75 3.60003 1.75V0.25ZM19.85 8.625H27V7.125H19.85V8.625ZM26.25 7.875V14.125H27.75V7.875H26.25ZM27 13.375H19.85V14.875H27V13.375ZM19.85 13.375C18.4413 13.375 17.35 12.2842 17.35 11H15.85C15.85 13.1676 17.6689 14.875 19.85 14.875V13.375ZM19.85 7.125C17.6689 7.125 15.85 8.83244 15.85 11H17.35C17.35 9.71578 18.4413 8.625 19.85 8.625V7.125ZM20.5 11.75H20.513V10.25H20.5V11.75Z" fill="white"/>
    //  </svg>
  ),

  offersLogin: (
    <svg
      width="55"
      height="45"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3447 3.23507C15.7207 2.90886 16.2793 2.90886 16.6553 3.23507L18.5313 4.86262C18.7633 5.06391 19.0749 5.14741 19.3765 5.08909L21.8148 4.61756C22.3036 4.52305 22.7874 4.80238 22.9499 5.27289L23.7607 7.62036C23.861 7.91068 24.0891 8.13881 24.3795 8.23909L26.7269 9.04992C27.1974 9.21243 27.4768 9.69626 27.3823 10.185L26.9107 12.6234C26.8524 12.9249 26.9359 13.2366 27.1372 13.4686L28.7648 15.3445C29.091 15.7205 29.091 16.2792 28.7648 16.6552L27.1372 18.5311C26.9359 18.7631 26.8524 19.0747 26.9107 19.3763L27.3823 21.8147C27.4768 22.3034 27.1974 22.7872 26.7269 22.9498L24.3795 23.7606C24.0891 23.8609 23.861 24.089 23.7607 24.3793L22.9499 26.7268C22.7874 27.1973 22.3036 27.4766 21.8148 27.3821L19.3765 26.9106C19.0749 26.8523 18.7633 26.9358 18.5313 27.1371L16.6553 28.7646C16.2793 29.0908 15.7207 29.0908 15.3447 28.7646L13.4687 27.1371C13.2367 26.9358 12.9251 26.8523 12.6235 26.9106L10.1851 27.3821C9.69641 27.4766 9.21259 27.1973 9.05007 26.7268L8.23924 24.3793C8.13896 24.089 7.91083 23.8609 7.62051 23.7606L5.27304 22.9498C4.80254 22.7872 4.5232 22.3034 4.61771 21.8147L5.08924 19.3763C5.14756 19.0747 5.06406 18.7631 4.86278 18.5311L3.23522 16.6552C2.90901 16.2792 2.90901 15.7205 3.23522 15.3445L4.86278 13.4686C5.06406 13.2366 5.14756 12.9249 5.08924 12.6234L4.61771 10.185C4.5232 9.69626 4.80254 9.21243 5.27304 9.04992L7.62051 8.23909C7.91083 8.13881 8.13896 7.91068 8.23924 7.62036L9.05007 5.27289C9.21259 4.80238 9.69641 4.52305 10.1851 4.61756L12.6235 5.08909C12.9251 5.14741 13.2367 5.06391 13.4687 4.86262L15.3447 3.23507Z"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M21.3334 10.6665L10.6667 21.3332"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0635 12.2163H12.101"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.0635 20.2163H20.101"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  superCoinsNew: (
    <></>
  ),

  accountCircle: (
    <svg width="42" height="42" viewBox="0 0 32 32" fill="#ffffff">
      <mask
        id="mask0_1_1751"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="#ffffff" />
      </mask>
      <g mask="url(#mask0_1_1751)">
        <path
          d="M7.5341 23.2664C8.84503 22.3778 10.1893 21.7002 11.5669 21.2336C12.945 20.7669 14.4229 20.5336 16.0005 20.5336C17.5781 20.5336 19.0613 20.7669 20.4501 21.2336C21.8394 21.7002 23.1896 22.3778 24.5005 23.2664C25.4114 22.1554 26.0725 21 26.4837 19.8C26.8949 18.6 27.1005 17.3333 27.1005 16C27.1005 12.8666 26.0338 10.2333 23.9005 8.09997C21.7672 5.96664 19.1338 4.89997 16.0005 4.89997C12.8672 4.89997 10.2338 5.96664 8.1005 8.09997C5.96717 10.2333 4.9005 12.8666 4.9005 16C4.9005 17.3333 5.1117 18.6 5.5341 19.8C5.95597 21 6.62263 22.1554 7.5341 23.2664ZM16.0005 17.1C14.7114 17.1 13.6226 16.6554 12.7341 15.7664C11.845 14.8778 11.4005 13.789 11.4005 12.5C11.4005 11.2109 11.845 10.1221 12.7341 9.23357C13.6226 8.3445 14.7114 7.89997 16.0005 7.89997C17.2896 7.89997 18.3784 8.3445 19.2669 9.23357C20.156 10.1221 20.6005 11.2109 20.6005 12.5C20.6005 13.8109 20.156 14.9053 19.2669 15.7832C18.3784 16.661 17.2896 17.1 16.0005 17.1ZM16.0005 29.3336C14.1562 29.3336 12.4173 28.9834 10.7837 28.2832C9.15063 27.5834 7.7341 26.628 6.5341 25.4168C5.3341 24.2056 4.38957 22.7944 3.7005 21.1832C3.01143 19.572 2.6669 17.8442 2.6669 16C2.6669 14.1557 3.01703 12.4224 3.7173 10.8C4.41703 9.17757 5.3725 7.76637 6.5837 6.56637C7.7949 5.36637 9.2061 4.4165 10.8173 3.71677C12.4285 3.0165 14.1562 2.66637 16.0005 2.66637C17.8448 2.66637 19.5781 3.0165 21.2005 3.71677C22.8229 4.4165 24.2341 5.36637 25.4341 6.56637C26.6341 7.76637 27.584 9.17757 28.2837 10.8C28.984 12.4224 29.3341 14.1557 29.3341 16C29.3341 17.8442 28.984 19.572 28.2837 21.1832C27.584 22.7944 26.6341 24.2056 25.4341 25.4168C24.2341 26.628 22.8229 27.5834 21.2005 28.2832C19.5781 28.9834 17.8448 29.3336 16.0005 29.3336Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  sellOutline: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1333 25.6666C13.8666 25.6666 13.6057 25.611 13.3506 25.4999C13.0946 25.3888 12.8777 25.2444 12.6999 25.0666L0.966585 13.3333C0.766585 13.1333 0.61103 12.911 0.499919 12.6666C0.388808 12.4221 0.333252 12.1555 0.333252 11.8666V2.33325C0.333252 1.7777 0.527919 1.3057 0.917252 0.917252C1.3057 0.527919 1.7777 0.333252 2.33325 0.333252H11.8666C12.1333 0.333252 12.3946 0.388808 12.6506 0.499919C12.9057 0.61103 13.1221 0.755474 13.2999 0.933252L25.0333 12.6666C25.4333 13.0666 25.6333 13.5497 25.6333 14.1159C25.6333 14.683 25.4444 15.1555 25.0666 15.5333L15.5333 25.0666C15.3555 25.2444 15.1444 25.3888 14.8999 25.4999C14.6555 25.611 14.3999 25.6666 14.1333 25.6666ZM14.0999 23.6666L23.6333 14.1333L11.8666 2.33325H2.33325V11.8666L14.0999 23.6666ZM7.66659 9.33325C8.13325 9.33325 8.52792 9.17192 8.85059 8.84925C9.17236 8.52748 9.33325 8.13325 9.33325 7.66659C9.33325 7.19992 9.17236 6.80525 8.85059 6.48259C8.52792 6.16081 8.13325 5.99992 7.66659 5.99992C7.19992 5.99992 6.8057 6.16081 6.48392 6.48259C6.16125 6.80525 5.99992 7.19992 5.99992 7.66659C5.99992 8.13325 6.16125 8.52748 6.48392 8.84925C6.8057 9.17192 7.19992 9.33325 7.66659 9.33325Z"
        fill="white"
      />
    </svg>
  ),
  sellBadge: (
    <svg
      width="27"
      height="27"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1_1756"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="#ffffff" />
      </mask>
      <g mask="url(#mask0_1_1756)">
        <path
          d="M17.1669 29.3336C16.8784 29.3336 16.5952 29.2835 16.3173 29.1832C16.0394 29.0835 15.7893 28.9224 15.5669 28.7L3.3005 16.4336C3.0781 16.2112 2.91703 15.9611 2.8173 15.6832C2.71703 15.4053 2.6669 15.1221 2.6669 14.8336V4.89998C2.6669 4.25572 2.8781 3.72238 3.3005 3.29998C3.7229 2.87758 4.25623 2.66638 4.9005 2.66638H14.8341C15.1226 2.66638 15.4114 2.71652 15.7005 2.81678C15.9896 2.91652 16.2562 3.07758 16.5005 3.29998L28.7005 15.5336C29.1672 16.0003 29.4005 16.5392 29.4005 17.1504C29.4005 17.7611 29.1672 18.2997 28.7005 18.7664L18.7669 28.7C18.5669 28.9 18.328 29.0555 18.0501 29.1664C17.7728 29.2779 17.4784 29.3336 17.1669 29.3336ZM8.3341 10.1336C8.82263 10.1336 9.25037 9.95572 9.6173 9.59998C9.9837 9.24425 10.1669 8.81092 10.1669 8.29998C10.1669 7.81092 9.9837 7.38878 9.6173 7.03358C9.25037 6.67785 8.82263 6.49998 8.3341 6.49998C7.84503 6.49998 7.41703 6.67785 7.0501 7.03358C6.6837 7.38878 6.5005 7.81092 6.5005 8.29998C6.5005 8.81092 6.6837 9.24425 7.0501 9.59998C7.41703 9.95572 7.84503 10.1336 8.3341 10.1336Z"
          fill="white"
        />
      </g>
    </svg>
  ),

  crossDark: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L12 12M12 12L6 18M12 12L6 6M12 12L18 18"
        stroke="#1A1A1A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  crossWhite: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1L7 7M7 7L1 13M7 7L1 1M7 7L13 13"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  superCoinsHotel: (
   <></>
  ),
  superCoins: (
   <></>
  ),
  tickFill: (
    <svg
      viewBox="0 0 20 20"
      className="c-white"
      height="16"
      width="16"
      style="color: rgb(71, 153, 27);"
    >
      <path
        d="M10 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm3.165 5.107l-4.803 4.139-1.929-2.214-1.13.986 2.42 2.776.071.072a.75.75 0 00.894.07l.09-.067 5.366-4.626-.98-1.136z"
        fill="currentColor"
        id="prefix__tick---fill"
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      />
    </svg>
  ),
  successSmall: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h12v12H0z" />
        <path
          stroke="#4BAC1C"
          strokeWidth=".75"
          fill="#4BAC1C"
          d="M4.602 7.672 2.651 5.821 2 6.438l2.602 2.468 5.576-5.289L9.528 3z"
        />
      </g>
    </svg>
  ),
  email: (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4 0H1.6C.72 0 0 .731 0 1.625v9.75C0 12.269.72 13 1.6 13h12.8c.88 0 1.6-.731 1.6-1.625v-9.75C16 .731 15.28 0 14.4 0zm0 3.25L8 7.313 1.6 3.25V1.625L8 5.688l6.4-4.063V3.25z"
        fill="#36C"
        fillRule="evenodd"
      />
    </svg>
  ),
  greenTick: (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.146 5.336a.5.5 0 0 1 0-.707l.384-.384a.5.5 0 0 1 .707 0l2.068 2.062a.5.5 0 0 0 .707 0l5.16-5.16a.5.5 0 0 1 .708 0l.386.389a.5.5 0 0 1-.001.706L5.012 8.494a.5.5 0 0 1-.707 0L1.146 5.336z"
        fill="#008C00"
        stroke="#008C00"
        strokeWidth=".5"
        fillRule="evenodd"
      />
    </svg>
  ),
  group: (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28z"
          fill="#E9F9D0"
        />
        <g transform="translate(10 10)">
          <circle
            stroke="#4BAC1C"
            strokeWidth="1.125"
            fill="#4BAC1C"
            cx="18"
            cy="18"
            r="17.438"
          />
          <path
            stroke="#FFF"
            strokeWidth=".844"
            fill="#FFF"
            d="m14.855 22.212-4.391-4.165L9 19.435l5.855 5.554 12.545-11.9-1.464-1.389z"
          />
        </g>
      </g>
    </svg>
  ),
  orange_tick_copy: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <rect fill="#F26822" width="32" height="32" rx="4.656" />
        <path
          fill="#FFF"
          d="m4.571 16.755 2.833-4.549 3.967 6.823 12.75-10.8 2.833 4.83-16.15 10.23z"
        />
      </g>
    </svg>
  ),
  link_icon_copy: (
    <svg
      width="24"
      height="11"
      viewBox="0 0 24 11"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6 0C21.58 0 24 2.465 24 5.5c0 3.037-2.42 5.5-5.4 5.5h-5.04c-.073 0-.152 0-.224-.015a4.83 4.83 0 0 1-1.34-.22A5.41 5.41 0 0 1 9.246 8.8a4.604 4.604 0 0 1-.461-.733 4.418 4.418 0 0 1-.31-.734A5.336 5.336 0 0 1 8.158 5.5c0-.645.109-1.262.317-1.833h1.966c.136 0 .266.014.396.044a3.35 3.35 0 0 0 0 3.577c.144.221.31.426.503.61a3.17 3.17 0 0 0 2.219.902h5.04c1.786 0 3.24-1.481 3.24-3.3 0-1.818-1.454-3.3-3.24-3.3h-2.132A6.916 6.916 0 0 0 14.632 0h3.967zM10.44 0c.08 0 .152 0 .224.014.46.008.907.09 1.332.22a5.35 5.35 0 0 1 2.75 1.966c.187.234.339.477.469.733.121.235.23.477.31.733a5.32 5.32 0 0 1 .316 1.833c0 .646-.107 1.261-.316 1.834H13.56c-.136 0-.274-.015-.396-.045a3.283 3.283 0 0 0 .518-1.789c0-.66-.187-1.275-.518-1.789a3.377 3.377 0 0 0-.505-.608 3.095 3.095 0 0 0-.662-.49A3.108 3.108 0 0 0 10.44 2.2h-5.04C3.614 2.2 2.16 3.68 2.16 5.5c0 1.818 1.454 3.3 3.24 3.3h2.138a6.975 6.975 0 0 0 1.83 2.2H5.4C2.42 11 0 8.535 0 5.5 0 2.462 2.42 0 5.4 0h5.041z"
        fill="#36C"
        fillRule="nonzero"
      />
    </svg>
  ),
  super_coin: (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M5 10c-2.80359583 0-5-2.16995833-5-4.939125C0 2.27041667 2.2431125 0 5 0c2.756875 0 5 2.27041667 5 5.060875C10 7.83004167 7.80358333 10 5 10z"
          id="a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M8.75645833 5.754625C8.75645833 7.854875 7.075 9.45395833 5 9.45395833c-2.07495 0-3.7552375-1.59908333-3.7552375-3.69933333 0-2.10020833 1.68145417-3.8021375 3.7552375-3.8021375 2.07383333 0 3.75645833 1.70310833 3.75645833 3.8021375z"
          fill="#FFC30D"
          fillRule="nonzero"
        />
        <path
          d="M5 10c-2.80359583 0-5-2.16995833-5-4.939125C0 2.27041667 2.2431125 0 5 0c2.756875 0 5 2.27041667 5 5.060875C10 7.83004167 7.80358333 10 5 10z"
          fill="#FD0"
          fillRule="nonzero"
        />
        <g>
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <g mask="url(#b)">
            <path
              d="M4.99945783.99515417C2.68277033.99515417.798137 2.90272917.798137 5.247625c0 2.31295833 1.8461 4.12479167 4.20132083 4.12479167 2.35520834 0 4.20129167-1.81066667 4.20129167-4.12479167 0-2.34489583-1.884625-4.25247083-4.20129167-4.25247083z"
              fill="#FFF"
              fillRule="nonzero"
            />
            <path
              d="M5.0332495.76505C2.71659117.76505.83195783 2.672625.83195783 5.0175c0 2.31295833 1.8461 4.12479167 4.20129167 4.12479167 2.35520833 0 4.20133387-1.81183334 4.20133387-4.12479167C9.2357495 2.672625 7.3511245.76505 5.0332495.76505z"
              fill="#F0A700"
              fillRule="nonzero"
            />
            <path
              d="M4.99945783.91712917c-2.3166875 0-4.20132083 1.907575-4.20132083 4.25245416 0 2.31295834 1.8461 4.12479167 4.20132083 4.12479167 2.35520834 0 4.20129167-1.81183333 4.20129167-4.12479167 0-2.34487916-1.884625-4.25245416-4.20129167-4.25245416z"
              fill="#FFC000"
              fillRule="nonzero"
            />
            <path
              d="M.85988251 5.08091667c-.01162051 2.3425 1.85432949 4.25125 4.16865866 4.26309224.56166666.00115776 1.118625-.11230058 1.63475-.33330058 2.13804166-.91008333 3.14225-3.4015 2.243125-5.56555C8.2524995 1.88624167 6.74504117.8698125 5.0717495.86148648 2.75741617.84972083.87161617 2.7383875.85988251 5.08091667zM2.1186495 2.16274583c.77650417-.78477916 1.81107083-1.21616666 2.90985-1.21616666 1.09995833 0 2.13216667.43020833 2.909875 1.21498333.77766667.78477917 1.20504167 1.826025 1.20504167 2.9358125 0 1.10979167-.42854167 2.15104167-1.20504167 2.93583333C7.16183283 8.818 6.12729117 9.249375 5.0284995 9.249375c-1.09877917 0-2.13334583-.431375-2.90985-1.21616667C1.34214117 7.24841667.91360367 6.206.91360367 5.097375c0-1.10860417.4285375-2.14985417 1.20504583-2.93462917z"
              fill="#D89309"
              opacity=".72"
            />
          </g>
        </g>
        <path
          d="M5.902625 1.09326667L2.5759 4.7725c-.4285375.47395833-.17632083 1.142875.45772917 1.12633333l1.9196625.01775c.09691666 0 .17516666.080375.174.17845834 0 .015375-.00233334.03070833-.00583334.04608333l-.77066666 2.84954167L7.650625 5.369375c.413375-.453875.09575-1.189-.51495833-1.189l-1.89395834.03545833c-.09691666.002375-.17633333-.07564583-.17866666-.17374166 0-.01772917.00233333-.03545834.007-.0531875.20204166-.71859167.806875-2.8696375.83258333-2.8956375z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  icon_gift_card: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#DB1F1F" fillRule="nonzero">
        <path d="M14.415 5.133h-2.707c.047-.015.093-.028.139-.046.22-.08.432-.187.629-.317a2.805 2.805 0 0 0 1.247-1.996 2.494 2.494 0 0 0-.728-2.016A2.592 2.592 0 0 0 9.626.505a3.15 3.15 0 0 0-.995 1.457 7.118 7.118 0 0 0-.267 1.051c0 .056-.024.111-.035.167 0-.056-.024-.111-.035-.169a7.021 7.021 0 0 0-.268-1.049A3.146 3.146 0 0 0 7.031.505a2.592 2.592 0 0 0-3.369.253 2.494 2.494 0 0 0-.727 2.016c.104.819.56 1.549 1.247 1.996.196.13.408.237.629.317.046.018.092.03.138.046H1.585C.709 5.133 0 5.851 0 6.737V8.46h16V6.737c0-.886-.71-1.604-1.585-1.604zM7.757 4.93l-.195-.035c-.24-.06-.483-.115-.728-.17-.584-.122-1.16-.279-1.725-.471a2.151 2.151 0 0 1-.438-.222 1.891 1.891 0 0 1-.864-1.355c-.047-.484.13-.963.48-1.297.327-.322.767-.5 1.223-.495a1.6 1.6 0 0 1 .986.322c.329.279.573.645.706 1.058.1.3.178.61.233.922.048.242.098.49.168.741.086.302.162.61.24.916 0 .033.015.069.023.102l-.11-.016zm2.067-.206c-.246.056-.49.111-.726.17l-.197.036-.11.018c0-.033.016-.066.024-.1.077-.308.154-.614.24-.92.07-.248.12-.497.168-.738.055-.313.132-.621.23-.923.135-.412.38-.779.708-1.058a1.6 1.6 0 0 1 .986-.321c.457-.006.897.172 1.223.494.35.334.526.812.48 1.295a1.891 1.891 0 0 1-.857 1.349 2.055 2.055 0 0 1-.438.221c-.567.195-1.145.354-1.731.477zM0 14.397C0 15.282.71 16 1.585 16h12.83c.876 0 1.585-.718 1.585-1.603v-5.05H0v5.05z" />
      </g>
    </svg>
  ),
  phone: (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.571 0H1.43C.643 0 0 .655 0 1.455v13.09C0 15.345.643 16 1.429 16H8.57C9.357 16 10 15.345 10 14.545V1.455C10 .655 9.357 0 8.571 0zm0 13.09H1.43V2.91H8.57v10.18z"
        fill="#36C"
        fillRule="evenodd"
      />
    </svg>
  ),
  visibility: (
    <svg
      width="16"
      height="11"
      viewBox="0 0 16 11"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0a8.57 8.57 0 0 0-8 5.5A8.57 8.57 0 0 0 8 11a8.57 8.57 0 0 0 8-5.5A8.57 8.57 0 0 0 8 0zm0 9.167c-2.036 0-3.636-1.614-3.636-3.667S5.964 1.833 8 1.833s3.636 1.614 3.636 3.667S10.036 9.167 8 9.167zM8 3.3c-1.236 0-2.182.953-2.182 2.2 0 1.247.946 2.2 2.182 2.2s2.182-.953 2.182-2.2c0-1.247-.946-2.2-2.182-2.2z"
        fill="#CCC"
        fillRule="evenodd"
      />
    </svg>
  ),
  visibility_off: (
   <></>
  ),
  arrowDown: (
    <svg
      width="14"
      height="9"
      fill="currentColor"
      className="t-all ml-2"
      style={{ transform: 'rotate(-180deg)', color: 'rgb(153, 153, 153)' }}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M15 12H-1V-4h16z" />
        <path
          stroke="#FFF"
          strokeWidth="0.5"
          fill="currentColor"
          d="M11.59 8L7 3.42 2.41 8 1 6.59l6-6 6 6z"
        />
      </g>
    </svg>
  ),
  flexiplus: (
    <svg
      width="84"
      height="22"
      viewBox="0 0 84 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <rect fill="#37404E" width="84" height="22" rx="11" />
        <text
          fontFamily="HelveticaNeue-CondensedBold, Helvetica Neue"
          fontSize="14"
          fontStyle="condensed"
          fontWeight="bold"
          fill="#FFF"
        >
          <tspan x="12" y="14">
            FLEXIPLUS
          </tspan>
        </text>
      </g>
    </svg>
  ),
  CANCEL: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path
          d="M7.473 13.333h-4.14V6.667h9.334v2.92L14 8.253V4c0-.733-.6-1.333-1.333-1.333H12V1.333h-1.333v1.334H5.333V1.333H4v1.334h-.667c-.74 0-1.326.6-1.326 1.333L2 13.333c0 .734.593 1.334 1.333 1.334h5.474l-1.334-1.334zM3.333 4h9.334v1.333H3.333V4zm7.694 11-2.36-2.36.94-.94 1.413 1.413 2.827-2.826.94.94L11.027 15zM6.94 9.333 8 10.393l-.94.94L6 10.273l-1.06 1.06-.94-.94 1.06-1.06L4 8.273l.94-.94L6 8.393l1.06-1.06.94.94-1.06 1.06z"
          fill="#4D4D4D"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  CANCELV2: (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="cancel" fillRule="nonzero" stroke="#FF3C2B">
          <path
            d="M12,0.5 C15.1754375,0.5 18.0504327,1.78728943 20.1315716,3.86842839 C22.2127106,5.94956735 23.5,8.8245625 23.5,12 C23.5,15.1754375 22.2127106,18.0504327 20.1315716,20.1315716 C18.0504327,22.2127106 15.1754375,23.5 12,23.5 C8.8245625,23.5 5.94956735,22.2127106 3.86842839,20.1315716 C1.78728943,18.0504327 0.5,15.1754375 0.5,12 C0.5,8.8245625 1.78728943,5.94956735 3.86842839,3.86842839 C5.94956735,1.78728943 8.8245625,0.5 12,0.5 Z M12,1 C8.96242857,1 6.21242871,2.23121451 4.22182161,4.22182161 C2.23121451,6.21242871 1,8.96242857 1,12 C1,15.0375714 2.23121451,17.7875713 4.22182161,19.7781784 C6.21242871,21.7687855 8.96242857,23 12,23 C15.0375714,23 17.7875713,21.7687855 19.7781784,19.7781784 C21.7687855,17.7875713 23,15.0375714 23,12 C23,8.96242857 21.7687855,6.21242871 19.7781784,4.22182161 C17.7875713,2.23121451 15.0375714,1 12,1 Z M17.5,11.75 L17.5,12.25 L7.5,12.25 L7.5,11.75 L17.5,11.75 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  ),
  AMEND: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path
          d="M13.333 2h-.666V.667h-1.334V2H4.667V.667H3.333V2h-.666c-.734 0-1.334.6-1.334 1.333V14c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333V3.333c0-.733-.6-1.333-1.334-1.333zm0 12H2.667V6.667h10.666V14zm0-8.667H2.667v-2h10.666v2z"
          fill="#4D4D4D"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  SEAT: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path
          d="M5.06 3.607a1.336 1.336 0 0 1 0-1.887c.52-.52 1.367-.52 1.887 0s.52 1.367 0 1.887a1.324 1.324 0 0 1-1.887 0zM4 10.667v-6H2.667v6A3.335 3.335 0 0 0 6 14h4v-1.333H6c-1.107 0-2-.894-2-2zm9.333 2.713L9.953 10H7.667V7.547c.933.766 2.4 1.44 3.666 1.44v-1.44c-1.106.013-2.406-.58-3.113-1.36l-.933-1.034a1.43 1.43 0 0 0-.46-.333 1.483 1.483 0 0 0-.64-.153h-.02c-.827 0-1.5.673-1.5 1.5V10c0 1.107.893 2 2 2h3.38l2.333 2.333.953-.953z"
          fill="#4D4D4D"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  MEAL: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path
          d="M.667 14.653c0 .374.3.674.673.674H10c.373 0 .673-.3.673-.674V14H.667v.653zm5-8.66c-2.5 0-5 1.34-5 4.007h10c0-2.667-2.5-4.007-5-4.007zM2.413 8.667c.74-1.034 2.314-1.34 3.254-1.34s2.513.306 3.253 1.34H2.413zM.667 11.333h10v1.334h-10v-1.334zm11.333-8V.667h-1.333v2.666H7.333l.154 1.334h6.373L12.927 14H12v1.333h1.147c.56 0 1.02-.433 1.086-.98l1.1-11.02H12z"
          fill="#4D4D4D"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  FLEXIFLY: (
    <svg width="30px" height="30px" viewBox="0 0 60 60">
      <defs>
        <linearGradient
          x1="50%"
          y1="-6.43983535%"
          x2="50%"
          y2="113.780299%"
          id="linearGradient-1"
        >
          <stop stopColor="#89D500" offset="0%" />
          <stop stopColor="#43A200" offset="100%" />
        </linearGradient>
      </defs>
      <g
        id="Master-templates"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Merchandising" transform="translate(-408.000000, -610.000000)">
          <g id="Group-12" transform="translate(392.000000, 588.000000)">
            <g id="Group-11" transform="translate(16.000000, 22.000000)">
              <circle id="Oval" fill="#FFFFFF" cx="30" cy="30" r="30" />
              <path
                d="M14.8511676,19.9679403 C24.5753308,15.8816019 35.5345381,15.8788533 45.2607498,19.9603133 L45.2607498,19.9603133 L45.6766931,20.1348577 C47.4066472,33.3391456 42.1941084,42.9608597 30.0390768,49 C24.7053021,46.1980128 20.7018324,42.8382194 18.0286678,38.9206198 L29.6588406,32.5916127 L31.0419928,41.2878442 L32.7074011,40.0516682 L33.7152856,30.0883768 L39.0681132,26.785142 C40.7939732,25.6128297 38.764898,23.0823633 37.0613,24.2400647 L31.8966258,27.4271899 L22.4239984,25.0042924 L20.7793942,26.2709104 L27.8401809,29.9304258 L16.988785,37.2506136 C14.2197215,32.3521591 13.3747792,26.6469072 14.453958,20.1348577 L14.453958,20.1348577 Z"
                id="Combined-Shape"
                fill="url(#linearGradient-1)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  'CT FLEX': (
    <svg width="30px" height="30px" viewBox="0 0 60 60">
      <defs>
        <linearGradient
          x1="50%"
          y1="-6.43983535%"
          x2="50%"
          y2="113.780299%"
          id="linearGradient-1"
        >
          <stop stopColor="#89D500" offset="0%" />
          <stop stopColor="#43A200" offset="100%" />
        </linearGradient>
      </defs>
      <g
        id="Master-templates"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Merchandising" transform="translate(-408.000000, -610.000000)">
          <g id="Group-12" transform="translate(392.000000, 588.000000)">
            <g id="Group-11" transform="translate(16.000000, 22.000000)">
              <circle id="Oval" fill="#FFFFFF" cx="30" cy="30" r="30" />
              <path
                d="M14.8511676,19.9679403 C24.5753308,15.8816019 35.5345381,15.8788533 45.2607498,19.9603133 L45.2607498,19.9603133 L45.6766931,20.1348577 C47.4066472,33.3391456 42.1941084,42.9608597 30.0390768,49 C24.7053021,46.1980128 20.7018324,42.8382194 18.0286678,38.9206198 L29.6588406,32.5916127 L31.0419928,41.2878442 L32.7074011,40.0516682 L33.7152856,30.0883768 L39.0681132,26.785142 C40.7939732,25.6128297 38.764898,23.0823633 37.0613,24.2400647 L31.8966258,27.4271899 L22.4239984,25.0042924 L20.7793942,26.2709104 L27.8401809,29.9304258 L16.988785,37.2506136 C14.2197215,32.3521591 13.3747792,26.6469072 14.453958,20.1348577 L14.453958,20.1348577 Z"
                id="Combined-Shape"
                fill="url(#linearGradient-1)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  FLEXIPLUS: (
    <svg
      width="11"
      height="9"
      viewBox="0 0 11 9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          filterUnits="objectBoundingBox"
          id="b"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.112447732 0 0 0 0 0.470504982 0 0 0 0 0 0 0 0 1 0"
            in="shadowOffsetOuter1"
          />
        </filter>
        <path
          d="M8.839.886 6.745 2.754l-4.457-.462-.648.713L5.1 4.22.622 8.557l.605.68L6.12 5.341 7.39 9.329l.66-.7-.287-4.755 2.17-1.935C10.626 1.265 9.52.22 8.839.886z"
          id="a"
        />
      </defs>
      <g transform="rotate(9 13.457 5.261)" fill="#006400" fillRule="evenodd">
        <use fill="#000" filter="url(#b)" xlinkHref="#a" />
        <use fill="#FFF" xlinkHref="#a" />
      </g>
    </svg>
  ),
  EZCANCEL: (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient x1="50%" y1="-31.726%" x2="50%" y2="100%" id="a">
          <stop stopColor="#FFC900" offset="0%" />
          <stop stopColor="#F77728" offset="100%" />
        </linearGradient>
        <path
          d="M.213 2.054c-.985 6.151 1.45 10.819 7.305 14.002 5.698-2.93 8.141-7.597 7.33-14.002L12.48 1.025a12.469 12.469 0 0 0-9.908.002L.212 2.054z"
          id="b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M.213 2.054c-.985 6.151 1.45 10.819 7.305 14.002 5.698-2.93 8.141-7.597 7.33-14.002L12.48 1.025a12.469 12.469 0 0 0-9.908.002L.212 2.054z"
          fill="url(#a)"
          fillRule="nonzero"
        />
        <g>
          <mask id="c" fill="#fff">
            <use xlinkHref="#b" />
          </mask>
          <path
            d="M7.466 3.25c2.217 0 4.014 1.748 4.014 3.904 0 2.156-1.797 3.903-4.014 3.903-2.217 0-4.013-1.747-4.013-3.903 0-2.156 1.796-3.904 4.013-3.904zm2.341 3.253H5.125v1.301h4.682V6.503z"
            fill="#FFF"
            fillRule="nonzero"
            mask="url(#c)"
          />
        </g>
      </g>
    </svg>
  ),
  TICK_ICON: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="9"
      fill="none"
      viewBox="0 0 12 9"
    >
      <path
        fill="#008C00"
        fillRule="evenodd"
        stroke="#008C00"
        strokeWidth="0.5"
        d="M1.077 5.265a.5.5 0 010-.707l.384-.384a.5.5 0 01.706 0l2.069 2.063a.5.5 0 00.707 0l5.16-5.161a.5.5 0 01.708.001l.386.388a.5.5 0 01-.001.706L4.943 8.424a.5.5 0 01-.707 0L1.077 5.265z"
        clipRule="evenodd"
      />
    </svg>
  ),
  LOUNGE: (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient x1="50%" y1="-31.726%" x2="50%" y2="100%" id="a">
          <stop stopColor="#FFC900" offset="0%" />
          <stop stopColor="#F77728" offset="100%" />
        </linearGradient>
        <path
          d="M.213 2.054c-.985 6.151 1.45 10.819 7.305 14.002 5.698-2.93 8.141-7.597 7.33-14.002L12.48 1.025a12.469 12.469 0 0 0-9.908.002L.212 2.054z"
          id="b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M.213 2.054c-.985 6.151 1.45 10.819 7.305 14.002 5.698-2.93 8.141-7.597 7.33-14.002L12.48 1.025a12.469 12.469 0 0 0-9.908.002L.212 2.054z"
          fill="url(#a)"
          fillRule="nonzero"
        />
        <g>
          <mask id="c" fill="#fff">
            <use xlinkHref="#b" />
          </mask>
          <path
            d="M7.466 3.25c2.217 0 4.014 1.748 4.014 3.904 0 2.156-1.797 3.903-4.014 3.903-2.217 0-4.013-1.747-4.013-3.903 0-2.156 1.796-3.904 4.013-3.904zm2.341 3.253H5.125v1.301h4.682V6.503z"
            fill="#FFF"
            fillRule="nonzero"
            mask="url(#c)"
          />
        </g>
      </g>
    </svg>
  ),
  UpgradeIcon: (
    <svg
      width="63"
      height="15"
      viewBox="0 0 63 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.90625 11.6709C4.51172 11.6709 5.04395 11.557 5.50293 11.3291C5.96517 11.1012 6.33301 10.7871 6.60645 10.3867C6.88314 9.98633 7.04102 9.52409 7.08008 9L7.08496 8.91699H5.35645L5.34668 8.97559C5.30762 9.21647 5.22298 9.42806 5.09277 9.61035C4.96582 9.79264 4.80143 9.93424 4.59961 10.0352C4.40104 10.1361 4.17155 10.1865 3.91113 10.1865C3.58236 10.1865 3.29915 10.097 3.06152 9.91797C2.82715 9.73568 2.64486 9.47852 2.51465 9.14648C2.3877 8.8112 2.32422 8.41406 2.32422 7.95508V7.94531C2.32422 7.48633 2.3877 7.09245 2.51465 6.76367C2.64486 6.43164 2.82715 6.17611 3.06152 5.99707C3.29915 5.81803 3.58073 5.72852 3.90625 5.72852C4.16341 5.72852 4.39453 5.78223 4.59961 5.88965C4.80469 5.99707 4.97233 6.14518 5.10254 6.33398C5.23275 6.52279 5.31413 6.73926 5.34668 6.9834L5.35156 7.02734H7.08008L7.0752 6.93945C7.04264 6.41862 6.88639 5.95638 6.60645 5.55273C6.3265 5.14583 5.95378 4.82682 5.48828 4.5957C5.02604 4.36133 4.4987 4.24414 3.90625 4.24414C3.19987 4.24414 2.59277 4.39388 2.08496 4.69336C1.57715 4.99284 1.1849 5.41927 0.908203 5.97266C0.634766 6.52604 0.498047 7.18522 0.498047 7.95019V7.95996C0.498047 8.72493 0.634766 9.38574 0.908203 9.94238C1.1849 10.4958 1.57715 10.9222 2.08496 11.2217C2.59603 11.5212 3.20313 11.6709 3.90625 11.6709ZM9.92676 11.4805H11.7188V5.875H13.75V4.43457H7.89551V5.875H9.92676V11.4805ZM20.5078 11.6709C21.1263 11.6709 21.6618 11.5618 22.1143 11.3437C22.57 11.1257 22.9216 10.8197 23.1689 10.4258C23.4196 10.0319 23.5449 9.57292 23.5449 9.04883V4.43457H21.7529V8.87793C21.7529 9.28483 21.6471 9.60547 21.4355 9.83984C21.224 10.071 20.9163 10.1865 20.5127 10.1865C20.1156 10.1865 19.8096 10.071 19.5947 9.83984C19.3799 9.60547 19.2725 9.28483 19.2725 8.87793V4.43457H17.4805V9.04883C17.4805 9.57617 17.6058 10.0368 17.8564 10.4307C18.1071 10.8213 18.4587 11.1257 18.9111 11.3437C19.3669 11.5618 19.8991 11.6709 20.5078 11.6709ZM25.0439 13.2773H26.7773V10.6064H26.8701C26.958 10.805 27.0785 10.9759 27.2314 11.1191C27.3877 11.2624 27.57 11.373 27.7783 11.4512C27.9867 11.526 28.2145 11.5635 28.4619 11.5635C28.9209 11.5635 29.3115 11.4544 29.6338 11.2363C29.9593 11.015 30.2067 10.696 30.376 10.2793C30.5485 9.86263 30.6348 9.35807 30.6348 8.76562V8.75586C30.6348 8.16992 30.5469 7.67025 30.3711 7.25684C30.1953 6.84017 29.9463 6.52116 29.624 6.2998C29.3018 6.07519 28.9144 5.96289 28.4619 5.96289C28.208 5.96289 27.9753 6.00032 27.7637 6.07519C27.5553 6.14681 27.3763 6.24935 27.2266 6.38281C27.0768 6.51628 26.958 6.67904 26.8701 6.87109H26.7773V6.0459H25.0439V13.2773ZM27.8223 10.1523C27.6107 10.1523 27.4251 10.097 27.2656 9.98633C27.1094 9.87565 26.9873 9.71615 26.8994 9.50781C26.8115 9.29948 26.7676 9.05208 26.7676 8.76562V8.75586C26.7676 8.46615 26.8099 8.21875 26.8945 8.01367C26.9824 7.80534 27.1045 7.64746 27.2607 7.54004C27.4202 7.42936 27.6074 7.37402 27.8223 7.37402C28.0371 7.37402 28.2227 7.42936 28.3789 7.54004C28.5384 7.65072 28.6605 7.81022 28.7451 8.01855C28.8298 8.22363 28.8721 8.4694 28.8721 8.75586V8.76562C28.8721 9.05208 28.8298 9.29948 28.7451 9.50781C28.6605 9.71289 28.5384 9.8724 28.3789 9.98633C28.2227 10.097 28.0371 10.1523 27.8223 10.1523ZM34.1943 13.3896C34.7738 13.3896 35.2734 13.3034 35.6934 13.1309C36.1165 12.9583 36.4421 12.7126 36.6699 12.3936C36.901 12.0778 37.0166 11.7018 37.0166 11.2656V6.0459H35.2832V6.92969H35.2148C35.1237 6.72461 35.0016 6.55046 34.8486 6.40723C34.6956 6.264 34.5166 6.15495 34.3115 6.08008C34.1064 6.00195 33.8802 5.96289 33.6328 5.96289C33.1738 5.96289 32.7799 6.07519 32.4512 6.2998C32.1224 6.52116 31.8701 6.83366 31.6943 7.2373C31.5186 7.64095 31.4307 8.11458 31.4307 8.6582V8.66797C31.4307 9.1888 31.5186 9.64453 31.6943 10.0352C31.8701 10.4225 32.1208 10.7253 32.4463 10.9434C32.7718 11.1582 33.1576 11.2656 33.6035 11.2656C33.8574 11.2656 34.0869 11.2347 34.292 11.1729C34.4971 11.1077 34.6761 11.0117 34.8291 10.8848C34.9821 10.7546 35.1042 10.5967 35.1953 10.4111H35.2881V11.3779C35.2881 11.6514 35.1969 11.8613 35.0147 12.0078C34.8324 12.1576 34.5752 12.2324 34.2432 12.2324C33.9567 12.2324 33.7337 12.1917 33.5742 12.1104C33.418 12.029 33.3219 11.9232 33.2861 11.793L33.2764 11.7637H31.5869V11.7979C31.626 12.1104 31.7497 12.387 31.958 12.6279C32.1663 12.8688 32.4577 13.056 32.832 13.1895C33.2064 13.3229 33.6605 13.3896 34.1943 13.3896ZM34.2432 9.99121C34.0251 9.99121 33.8379 9.93587 33.6816 9.8252C33.5286 9.71452 33.4098 9.5599 33.3252 9.36133C33.2438 9.16276 33.2031 8.93001 33.2031 8.66309V8.65332C33.2031 8.38639 33.2438 8.15527 33.3252 7.95996C33.4098 7.76139 33.5286 7.6084 33.6816 7.50098C33.8379 7.3903 34.0251 7.33496 34.2432 7.33496C34.4645 7.33496 34.6533 7.3903 34.8096 7.50098C34.9691 7.6084 35.0895 7.76139 35.1709 7.95996C35.2555 8.15853 35.2979 8.39128 35.2979 8.6582V8.66797C35.2979 8.93164 35.2555 9.16276 35.1709 9.36133C35.0895 9.5599 34.9691 9.71452 34.8096 9.8252C34.6533 9.93587 34.4645 9.99121 34.2432 9.99121ZM38.3643 11.4805H40.0977V8.60937C40.0977 8.35547 40.1481 8.14062 40.249 7.96484C40.3532 7.78581 40.5013 7.65072 40.6934 7.55957C40.8854 7.46517 41.1165 7.41797 41.3867 7.41797C41.5072 7.41797 41.6292 7.42611 41.7529 7.44238C41.8766 7.45866 41.9954 7.48307 42.1094 7.51562V6.05078C42.0247 6.02148 41.932 6.00032 41.8311 5.9873C41.7301 5.97103 41.626 5.96289 41.5186 5.96289C41.1735 5.96289 40.8854 6.0459 40.6543 6.21191C40.4264 6.37793 40.2718 6.61068 40.1904 6.91016H40.0977V6.0459H38.3643V11.4805Z"
        fill="#F77728"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.0772 6.12012H48.5832V11.238H46.9589V9.18013L44.8638 11.2081L43.7331 10.0969L46.2326 7.64065H43.4653L44.0772 6.12012Z"
        fill="#F77728"
      />
      <path
        d="M51.6216 11.5635C52.009 11.5635 52.3394 11.4837 52.6128 11.3242C52.8862 11.1647 53.0864 10.9401 53.2134 10.6504H53.3062V11.4805H55.0396V4.00488H53.3062V6.91992H53.2134C53.0832 6.62044 52.8781 6.38607 52.5981 6.2168C52.3215 6.04753 51.9959 5.96289 51.6216 5.96289C51.1626 5.96289 50.772 6.07357 50.4497 6.29492C50.1274 6.51302 49.88 6.8304 49.7075 7.24707C49.5382 7.66374 49.4536 8.16667 49.4536 8.75586V8.76562C49.4536 9.35156 49.5399 9.85286 49.7124 10.2695C49.8882 10.6862 50.1388 11.0068 50.4644 11.2314C50.7899 11.4528 51.1756 11.5635 51.6216 11.5635ZM52.2612 10.1523C52.0464 10.1523 51.8608 10.097 51.7046 9.98633C51.5483 9.87565 51.4263 9.71777 51.3384 9.5127C51.2537 9.30436 51.2114 9.05534 51.2114 8.76562V8.75586C51.2114 8.47266 51.2537 8.22852 51.3384 8.02344C51.4263 7.8151 51.5483 7.6556 51.7046 7.54492C51.8641 7.43099 52.0496 7.37402 52.2612 7.37402C52.4761 7.37402 52.6616 7.42936 52.8179 7.54004C52.9774 7.65072 53.1011 7.81022 53.189 8.01855C53.2769 8.22363 53.3208 8.47103 53.3208 8.76074V8.77051C53.3208 9.05697 53.2769 9.30436 53.189 9.5127C53.1043 9.71777 52.9823 9.87565 52.8228 9.98633C52.6665 10.097 52.4793 10.1523 52.2612 10.1523ZM58.9165 11.6074C59.3527 11.6074 59.7254 11.5521 60.0347 11.4414C60.3439 11.3307 60.5978 11.1891 60.7964 11.0166C60.9982 10.8441 61.1528 10.6618 61.2603 10.4697C61.3709 10.2744 61.4442 10.097 61.48 9.9375L61.4946 9.87891L59.9126 9.88379L59.898 9.90332C59.8752 9.94889 59.8247 10.0091 59.7466 10.084C59.6717 10.1589 59.5675 10.2272 59.4341 10.2891C59.3039 10.3477 59.1427 10.377 58.9507 10.377C58.7261 10.377 58.5324 10.3281 58.3696 10.2305C58.2101 10.1296 58.0881 9.9847 58.0034 9.7959C57.9188 9.6071 57.8765 9.38086 57.8765 9.11719V8.41895C57.8765 8.14876 57.9188 7.91927 58.0034 7.73047C58.0913 7.54167 58.2118 7.39844 58.3647 7.30078C58.5177 7.19987 58.6952 7.14941 58.897 7.14941C59.0988 7.14941 59.2746 7.19824 59.4243 7.2959C59.5773 7.39355 59.6961 7.53678 59.7808 7.72559C59.8654 7.91113 59.9077 8.14225 59.9077 8.41895V9.10742L60.7085 8.14551H57.0317V9.15137H61.5288V8.65332C61.5288 8.09993 61.4198 7.61816 61.2017 7.20801C60.9836 6.79785 60.6743 6.48047 60.2739 6.25586C59.8735 6.03125 59.3999 5.91894 58.853 5.91894C58.3062 5.91894 57.8325 6.0345 57.4321 6.26562C57.0317 6.49349 56.7209 6.82064 56.4995 7.24707C56.2814 7.67025 56.1724 8.1748 56.1724 8.76074V8.76562C56.1724 9.35482 56.283 9.861 56.5044 10.2842C56.7257 10.7074 57.0399 11.0345 57.4468 11.2656C57.8569 11.4935 58.3468 11.6074 58.9165 11.6074Z"
        fill="#F77728"
      />
    </svg>
  ),
  crossBtn: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0.5C15.0744 0.5 17.9573 1.69475 20.1313 3.86871C22.3053 6.04266 23.5 8.9256 23.5 12C23.5 15.0744 22.3053 17.9573 20.1313 20.1313C17.9573 22.3053 15.0744 23.5 12 23.5C8.9256 23.5 6.04266 22.3053 3.86871 20.1313C1.69475 17.9573 0.5 15.0744 0.5 12C0.5 8.9256 1.69475 6.04266 3.8687 3.86871C6.04266 1.69475 8.9256 0.5 12 0.5Z"
        stroke="black"
      />
      <path
        d="M17.2877 6.71248C17.0201 6.4448 16.5908 6.4448 16.3231 6.71248L11.9999 11.0357L7.67663 6.71248C7.40896 6.4448 6.97966 6.4448 6.71199 6.71248C6.44431 6.98015 6.44431 7.40945 6.71199 7.67712L11.0352 12.0004L6.71199 16.3236C6.44431 16.5913 6.44431 17.0206 6.71199 17.2882C6.8433 17.4195 7.02007 17.4903 7.19179 17.4903C7.3635 17.4903 7.54027 17.4246 7.67158 17.2882L11.9948 12.965L16.3181 17.2882C16.4494 17.4195 16.6261 17.4903 16.7978 17.4903C16.9746 17.4903 17.1463 17.4246 17.2776 17.2882C17.5453 17.0206 17.5453 16.5913 17.2776 16.3236L12.9645 12.0004L17.2877 7.67712C17.5554 7.40945 17.5554 6.98015 17.2877 6.71248Z"
        fill="black"
      />
    </svg>
  ),
  emailSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="34"
      fill="none"
      viewBox="0 0 36 34"
    >
      <ellipse cx="18" cy="17.055" fill="#D6E8FC" rx="18" ry="16.945" />
    </svg>
  ),
  upgradeTick: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      class="c-primary-500 ml-1"
    >
      <path
        d="M0 6C0 2.68629 2.68629 0 6 0V0C9.31371 0 12 2.68629 12 6V6C12 9.31371 9.31371 12 6 12V12C2.68629 12 0 9.31371 0 6V6Z"
        fill="#F77728"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.7173 3L9 3V9H7.09567V6.58744L4.63953 8.9649L3.31395 7.66222L6.24419 4.78262H3L3.7173 3Z"
        fill="white"
      />
    </svg>
  ),
  Warning: (
    <svg width="19" height="19" viewBox="0 0 19 19">
      <g fill-rule="nonzero" fill="none">
        <path
          d="M9.5 0C4.26178906 0 0 4.26178906 0 9.5 0 14.7382109 4.26178906 19 9.5 19c5.2382109 0 9.5-4.2617891 9.5-9.5C19 4.26178906 14.7382109 0 9.5 0z"
          fill="#F5A623"
        />
        <path
          d="M9.48861979 12.7459447c.55336341 0 1.00195311.4485897 1.00195311 1.0019531s-.4485897 1.0019531-1.00195311 1.0019531c-.55336343 0-1.00195312-.4485897-1.00195312-1.0019531s.44858969-1.0019531 1.00195312-1.0019531zm0-8.43927803c.40991016 0 .74218751.33227734.74218751.7421875h0V9.8282819c0 .4099102-.33227735.7421875-.74218751.7421875-.40991015 0-.7421875-.3322773-.7421875-.7421875h0V5.04885417c0-.40991016.33227735-.7421875.7421875-.7421875z"
          stroke="#FFF"
          stroke-width=".63333333"
          fill="#FFF"
        />
      </g>
    </svg>
  ),
  ctadvantage: (
    <></>
   ),
  slideOne: (
   <></>
  ),
  slideTwo: (
  <></>
  ),
  slideThree: (
    <></>
  ),
  sliderClose: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1L5 5M5 5L1 9M5 5L1 1M5 5L9 9"
        stroke="#1A1A1A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
const SVGComponent = ({ svgIcon }) => svgIcon && componentMap[svgIcon]

export default SVGComponent
